import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Grid,
  ButtonBase,
} from '@mui/material';
import { FieldType } from '../../../../shared/types/appTypes';
import { FIELD_TYPE_OPTIONS } from '../types';
import FieldTypeIcon from './FieldTypeIcon';

interface FieldTypePaletteProps {
  onAddField: (type: FieldType) => void;
}

const FieldTypePalette: React.FC<FieldTypePaletteProps> = ({ onAddField }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Add Field
      </Typography>
      <Grid container spacing={1}>
        {FIELD_TYPE_OPTIONS.map((option) => (
          <Grid item xs={12} key={option.type}>
            <ButtonBase
              onClick={() => onAddField(option.type)}
              sx={{
                width: '100%',
                p: 1.5,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 1.5,
                transition: 'all 0.2s',
                '&:hover': {
                  bgcolor: 'action.hover',
                  borderColor: 'primary.main',
                },
              }}
            >
              <FieldTypeIcon type={option.type} color="primary" />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {option.label}
              </Typography>
            </ButtonBase>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default FieldTypePalette;
